import { SavedReport } from "Services/Api/Reports/Types";
import { TFunction } from "i18next";
import ActionsButton from "./ActionsButton";
import { STANDARD_REPORT_TYPE_MAP } from "Pages/Reports/Standard/Standard.constants";
import { OptionalValue, Tooltip } from "Components";
import { REPORT_FREQUENCIES_MAP } from "Pages/Report/EditReport/EditReport.constants";
import InfinityScrollWrapper from "Components/InfinityScroll/InfinityScrollWrapper";

const MobileView = ({ records, totalCount, setCurrentPage, t }: { records: SavedReport[], t: TFunction, totalCount: number, setCurrentPage: () => void }) => {
    return <div className="records-section">
        <InfinityScrollWrapper
            dataLength={records.length}
            hasMore={records.length < totalCount}
            onLoadMore={() => setTimeout(setCurrentPage, 500)}
            height={600}
            endMessageText={t('phishingManager.campaignSetup.step3.property.allItemLoaded')}
            scrollableId="saved-report-scroll-container"
        >
            {records.map(record => {
                const [firstEmail, ...rest] = (record?.emailsList || []).filter(item => !!item);
                const restEmailCount = (rest?.length || 0);
                return <div key={record.id} className="record">
                    <div className="row">
                        <span className="title">{record.name}</span>
                        <ActionsButton report={record} isMobile={true} />
                    </div>
                    <div className="row">
                        <span className="label">{t('reports.tabs.saved.columns.reportType')}</span>
                        <span className="title">{STANDARD_REPORT_TYPE_MAP[record.reportType]?.label(t) ?? ''}</span>
                    </div>
                    <div className="row">
                        <span className="label">{t('reports.tabs.saved.columns.recurrenceType')}</span>
                        <span className="title">{<OptionalValue>
                            {record.recurrenceType && t(REPORT_FREQUENCIES_MAP[record.recurrenceType]?.label)}
                        </OptionalValue>}</span>
                    </div>
                    <div className="row">
                        <span className="label">{t('reports.tabs.saved.columns.emailsList')}</span>
                        <span className="title">
                            <Tooltip
                                trigger={"hover"}
                                placement="top"
                                enabled={!!restEmailCount}
                                title={record?.emailsList?.join(", ")}
                                overlayClassName="info-tooltip">
                                <div>{firstEmail ? restEmailCount ? restEmailCount + 1 : firstEmail : "-"}</div>
                            </Tooltip>
                        </span>
                    </div>
                </div>
            })}
        </InfinityScrollWrapper>
    </div>
}

export default MobileView;